// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alignRight {
    text-align: right;
}

.modalError {
    font-weight: bold;
    margin-top: 10px;
}

::ng-deep .p-datatable .p-datatable-header {
    color: black;
    background: #f5f5f5;
    padding: 0;
    border: none;
}

::ng-deep .p-datatable-thead > tr > th {
    background-color: silver !important;
    font-size: 12px;
}

::ng-deep
    .p-datatable.p-datatable-striped
    .p-datatable-tbody
    > tr:nth-child(even) {
    background: #f4f4f4 !important;
}

::ng-deep .p-dialog .p-dialog-header {
    background: #336699;
}

::ng-deep .p-dialog .p-dialog-content {
    background: #336699;
}

::ng-deep .p-dialog .p-dialog-header .p-dialog-title {
    color: #fff;
    font-size: 16px;
}

:host ::ng-deep .p-dialog-header-close-icon {
    color: white;
    font-size: 2rem;
}
#results-table td {
    font-weight: normal;
    font-size: 11px;
    vertical-align: top;
}

.negativeField {
    color: red;
}

span.link {
    color: blue;
    cursor: pointer;
}

span.forTitles {
    font-style: italic;
    font-size: 150%;
}

tr.groupSummary td,
tr.groupSummary span {
    background-color: #b6d0e2; /*Light Blue*/
    font-weight: bolder;
}

tr.groupSummary2 td,
tr.groupSummary2 span {
    background-color: #e8e8e8; /*Gray*/
    font-weight: bolder;
}

tr.groupSummary3 td,
tr.groupSummary3 span {
    background-color: #e9c462; /*Pale Gold*/
    font-weight: bolder;
}

tr.groupSummary4 td,
tr.groupSummary4 span {
    background-color: #033663; /*Dark Blue*/
    color: white;
    font-weight: bolder;
}
`, "",{"version":3,"sources":["webpack://./src/app/utilities/invoice-upload/invoice-upload-results/invoice-upload-results.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,eAAe;AACnB;;AAEA;;;;IAII,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,yBAAyB,EAAE,aAAa;IACxC,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB,EAAE,OAAO;IAClC,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB,EAAE,YAAY;IACvC,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB,EAAE,YAAY;IACvC,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".alignRight {\r\n    text-align: right;\r\n}\r\n\r\n.modalError {\r\n    font-weight: bold;\r\n    margin-top: 10px;\r\n}\r\n\r\n::ng-deep .p-datatable .p-datatable-header {\r\n    color: black;\r\n    background: #f5f5f5;\r\n    padding: 0;\r\n    border: none;\r\n}\r\n\r\n::ng-deep .p-datatable-thead > tr > th {\r\n    background-color: silver !important;\r\n    font-size: 12px;\r\n}\r\n\r\n::ng-deep\r\n    .p-datatable.p-datatable-striped\r\n    .p-datatable-tbody\r\n    > tr:nth-child(even) {\r\n    background: #f4f4f4 !important;\r\n}\r\n\r\n::ng-deep .p-dialog .p-dialog-header {\r\n    background: #336699;\r\n}\r\n\r\n::ng-deep .p-dialog .p-dialog-content {\r\n    background: #336699;\r\n}\r\n\r\n::ng-deep .p-dialog .p-dialog-header .p-dialog-title {\r\n    color: #fff;\r\n    font-size: 16px;\r\n}\r\n\r\n:host ::ng-deep .p-dialog-header-close-icon {\r\n    color: white;\r\n    font-size: 2rem;\r\n}\r\n#results-table td {\r\n    font-weight: normal;\r\n    font-size: 11px;\r\n    vertical-align: top;\r\n}\r\n\r\n.negativeField {\r\n    color: red;\r\n}\r\n\r\nspan.link {\r\n    color: blue;\r\n    cursor: pointer;\r\n}\r\n\r\nspan.forTitles {\r\n    font-style: italic;\r\n    font-size: 150%;\r\n}\r\n\r\ntr.groupSummary td,\r\ntr.groupSummary span {\r\n    background-color: #b6d0e2; /*Light Blue*/\r\n    font-weight: bolder;\r\n}\r\n\r\ntr.groupSummary2 td,\r\ntr.groupSummary2 span {\r\n    background-color: #e8e8e8; /*Gray*/\r\n    font-weight: bolder;\r\n}\r\n\r\ntr.groupSummary3 td,\r\ntr.groupSummary3 span {\r\n    background-color: #e9c462; /*Pale Gold*/\r\n    font-weight: bolder;\r\n}\r\n\r\ntr.groupSummary4 td,\r\ntr.groupSummary4 span {\r\n    background-color: #033663; /*Dark Blue*/\r\n    color: white;\r\n    font-weight: bolder;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
